import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import { UpdateParameterValues } from "../services/City";
import {
  Box,
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Dialog,
  DialogActions,
  Typography,
} from "@material-ui/core";
function SaleCost(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [IsReadOnly, SetReadOnly] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  React.useEffect(() => {


    var structuretype = props.structureType;
    if (props.id == 258) {
      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 287 && item.structureType == props.structureType).value == 'true') {
        document.getElementById("row-" + structuretype + "-198").style.display = "none";
        document.getElementById("row1-" + structuretype + "-198").style.display = "none";
        document.getElementById("row-" + structuretype + "-229").style.display = "none";
        document.getElementById("row-" + structuretype + "-201").style.display = "none";
        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-200").style.display = "none";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {
        //   document.getElementById("row-"+structuretype+"-201").style.display = "none";
        // }
        // if(structuretype=="Apartment" || structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-202").style.display = "none";
        // }
      }
      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 288 && item.structureType == props.structureType).value == 'true') {

        document.getElementById("row-" + structuretype + "-110").style.display = "none";
        document.getElementById("row1-" + structuretype + "-110").style.display = "none";
        document.getElementById("row-" + structuretype + "-99").style.display = "none";


        document.getElementById("row-" + structuretype + "-239").style.display = "none";


      }

    }

    if (props.isSite == 0) {
      SetReadOnly(true);
    }
    if ((props.structureType == "Single Family" || props.structureType == "Apartment") && props.id == 258) {
      SetReadOnly(true);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }

    if (props.id == 260 || props.id == 261 || props.id == 262 || props.id == 140 || props.id == 252 || props.id == 3252 || props.id == 254 || props.id == 3254 || props.id == 258 || props.id == 257) {

      if (props.wholeEl.ischecked === true) {
        if (props.id != 249 && props.id != 37 && props.id != 250 && props.id != 251 && props.id != 38 && props.id != 252
          && props.id != 253 && props.id != 39 && props.id != 254 && props.id != 256 && props.id != 36 && props.id != 258) {
          SetStyle("form-control construction  ischecked");
        }
      }
      else {
        SetStyle("form-control construction");
      }
    }
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 255 || props.id == 3255) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control  Prowidth2 RightTop ischecked");
      }
      else {
        SetStyle("form-control  Prowidth2 RightTop");
      }
    }
    if (props.id == 278 || props.id == 279) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control  Prowidth2  ischecked");
      }
      else {
        SetStyle("form-control  Prowidth2 ");
      }
    }
    if (props.id == 256 || props.id == 3256) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftTop leftBottom ischecked");
      }
      else {
        SetStyle("form-control construction leftTop leftBottom");
      }
    }
    if ((props.id == 258 || props.id == 3258) && (props.structureType != "Single Family")) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction RightTop RightBottom  ischecked");
      }
      else {
        SetStyle("form-control construction RightTop RightBottom ");
      }
    }
    if (((props.id == 258 || props.id == 3258) && props.structureType == "Single Family")) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction RightBottom  ischecked");
      }
      else {
        SetStyle("form-control construction  RightBottom ");
      }
    }
    if (((props.id == 36 || props.id == 336) && props.structureType == "Single Family")) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftBottom  ischecked");
      }
      else {
        SetStyle("form-control construction  leftBottom ");
      }
    }
    if ((props.id == 249 || props.id == 3249)) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftTop ischecked");
      }
      else {
        SetStyle("form-control construction leftTop");
      }
    }

    if (props.id == 250 || props.id == 3250) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction RightTop ischecked");
      }
      else {
        SetStyle("form-control construction RightTop ");
      }
    }
    if (props.id == 247 || props.id == 3247) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftBottom ischecked");
      }
      else {
        SetStyle("form-control construction leftBottom");
      }
    }
    if (props.id == 140) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction RightBottom ischecked");
      }
      else {
        SetStyle("form-control construction RightBottom");
      }
    }
    if (props.id == 134) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftBottom ischecked");
      }
      else {
        SetStyle("form-control construction  leftBottom");
      }
    }
    if (props.id == 248) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction RightBottom RightTop ischecked");
      }
      else {
        SetStyle("form-control construction RightBottom RightTop");
      }
    }
    if (props.id == 41) {
      if (props.wholeEl.ischecked === true) {
        SetStyle("form-control construction leftTop ischecked");
      }
      else {
        SetStyle("form-control construction  leftTop");
      }
    }

    if (props.wholeEl.ischecked === true) {

      var pclass = IsStyle;
      SetStyle(pclass + " ischecked");
    }
    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);

    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);


  }, []);



  const openpopup = (e) => {
    setModalShow(true);
  }
  const onChange = (e) => {


    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";


    setchecked(e.target.checked);
    setchecked1(e.target.checked);

    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    document.getElementById(structuretype + "-" + parameterid).style.background = "#e7f0fa";

    if (structuretype == "Single Family") {
      if (parameterid == 37) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";

      }
      if (parameterid == 249) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";

      }
      if (parameterid == 250) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";

      }

      if (parameterid == 251) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

      }
      if (parameterid == 38) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

      }
      if (parameterid == 252) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";

      }
      if (parameterid == 253) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

      }
      if (parameterid == 39) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

      }
      if (parameterid == 254) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";

      }
    }
    if (parameterid == 256) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";

      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-258").style.background = "#f7fafd";

    }
    if (parameterid == 36) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";

      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-258").style.background = "#f7fafd";

    }

    if (parameterid == 258) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";

    }


    if (checkid.includes("41")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 259 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 255 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-259").style.background = "#f7fafd";
      document.getElementById(structuretype + "-255").style.background = "#f7fafd";
    }



    if (checkid.includes("259")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 41 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 255 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-41").style.background = "#f7fafd";
      document.getElementById(structuretype + "-255").style.background = "#f7fafd";

    }
    if (checkid.includes("255")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 41 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 259 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-259").style.background = "#f7fafd";
      document.getElementById(structuretype + "-41").style.background = "#f7fafd";

    }
    if (checkid.includes("43")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 260 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-260").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 278 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-278").style.background = "#f7fafd";
    }
    if (checkid.includes("44")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 261 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-261").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 279 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-279").style.background = "#f7fafd";
    }
    if (checkid.includes("278")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 43 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-43").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 260 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-260").style.background = "#f7fafd";

    }
    if (checkid.includes("260")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 43 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-43").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 278 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-278").style.background = "#f7fafd";

    }
    if (checkid.includes("261")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 44 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-44").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 279 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-279").style.background = "#f7fafd";

    }
    if (checkid.includes("279")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 261 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-261").style.background = "#f7fafd";
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 44 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-44").style.background = "#f7fafd";

    }
    if (checkid.includes("42")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 262 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-262").style.background = "#f7fafd";

    }
    if (checkid.includes("262")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 42 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-42").style.background = "#f7fafd";

    }
    if (checkid.includes("375")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 257 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 130 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-257").style.background = "#f7fafd";
      document.getElementById(structuretype + "-130").style.background = "#f7fafd";
    }
    if (checkid.includes("130")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 257 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 375 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-257").style.background = "#f7fafd";
      document.getElementById(structuretype + "-375").style.background = "#f7fafd";
    }
    if (checkid.includes("257")) {
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 130 && item.structureType == structuretype).ischecked = false;
      props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 375 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-130").style.background = "#f7fafd";
      document.getElementById(structuretype + "-375").style.background = "#f7fafd";
    }
    props.setData({ ...props.wholeEl, value: e.target.value, ischecked: true })

    if (e.target.value != "") {
      UpdateParameterValues(structuretype, props);
      // document.getElementById(e.target.id).value="0";

      //   var formID=Cookies.get('FormID');
      // let newArr =[];
      //   newArr=({
      //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
      //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
      //  });

      //  var name=Cookies.get('username');
      //  let params = {
      //   username: name,
      //   Stage:"P",
      //   formId: formID,
      //   userType:"AutoSave",
      //   parameters: []
      //  };
      //  params.StructureTypes=[{
      //   StructureType: structuretype,
      //   Calculations: [newArr],}
      //  ]
      //  params = JSON.stringify({
      //    Body: params,
      //  });
      //  console.log(params)
      //  return axios
      //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
      //      headers: {
      //        "Content-Type": "application/json",
      //        Accept: "application/json",
      //      },
      //      crossorigin: true,
      //    })
      //    .then((res) => {
      //    // setLoading(false);
      //      return res.data;
      //    })
      //    .catch((e) => {
      //    // setLoading(false);
      //      alert(e.message);
      //    });  
    }

  };



  function setPreviousValue(ID) {
    let e = ID.split('-')[1];

    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    if (previuosID == 198) {
      document.getElementById(StructureType + "-198").style.background = color1;
      document.getElementById(StructureType + "-229").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-201").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-202").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-200").style.background = color2;
      }
    }

    if (previuosID == 186) {
      document.getElementById(StructureType + "-186").style.background = color1;
      document.getElementById(StructureType + "-224").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-208").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-209").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-223").style.background = color2;
      }
    }
    if (previuosID == 88) {
      document.getElementById(StructureType + "-88").style.background = color1;
      document.getElementById(StructureType + "-238").style.background = color2;
    }
    if (previuosID == 89) {
      document.getElementById(StructureType + "-89").style.background = color1;
      document.getElementById(StructureType + "-237").style.background = color2;
    }
    if (previuosID == 91) {
      document.getElementById(StructureType + "-91").style.background = color1;
      document.getElementById(StructureType + "-236").style.background = color2;
    }
    if (previuosID == 105) {
      document.getElementById(StructureType + "-105").style.background = color1;
      document.getElementById(StructureType + "-235").style.background = color2;
    }
    if (previuosID == 90) {
      document.getElementById(StructureType + "-90").style.background = color1;
      document.getElementById(StructureType + "-234").style.background = color2;
    }
    if (previuosID == 106) {
      document.getElementById(StructureType + "-106").style.background = color1;
      document.getElementById(StructureType + "-233").style.background = color2;
    }
    if (previuosID == 87) {
      document.getElementById(StructureType + "-87").style.background = color1;
      document.getElementById(StructureType + "-232").style.background = color2;
    }
    if (previuosID == 109) {
      document.getElementById(StructureType + "-109").style.background = color1;
      document.getElementById(StructureType + "-97").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 113) {
      document.getElementById(StructureType + "-113").style.background = color1;
      document.getElementById(StructureType + "-102").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 114) {
      document.getElementById(StructureType + "-114").style.background = color1;
      document.getElementById(StructureType + "-103").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 112) {
      document.getElementById(StructureType + "-112").style.background = color1;
      document.getElementById(StructureType + "-100").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 111) {
      document.getElementById(StructureType + "-111").style.background = color1;
      document.getElementById(StructureType + "-101").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 110) {
      document.getElementById(StructureType + "-110").style.background = color1;
      document.getElementById(StructureType + "-99").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }

    if (previuosID == 45) {
      document.getElementById(StructureType + "-45").style.background = color1;
      document.getElementById(StructureType + "-246").style.background = color2;
      document.getElementById(StructureType + "-181").style.background = color3;
    }

    if (previuosID == 226) {
      document.getElementById(StructureType + "-226").style.background = color2;
      document.getElementById(StructureType + "-248").style.background = color3;
    }
    if (previuosID == 256) {
      document.getElementById(StructureType + "-256").style.background = color1;
      document.getElementById(StructureType + "-36").style.background = color2;

      document.getElementById(StructureType + "-258").style.background = color3;


    }
    if (previuosID == 41) {
      document.getElementById(StructureType + "-41").style.background = color1;
      document.getElementById(StructureType + "-259").style.background = color2;
      document.getElementById(StructureType + "-255").style.background = color3;
    }

    if (previuosID == 43) {
      document.getElementById(StructureType + "-278").style.background = color1;
      document.getElementById(StructureType + "-43").style.background = color2;
      document.getElementById(StructureType + "-260").style.background = color3;
    }
    if (previuosID == 44) {
      document.getElementById(StructureType + "-279").style.background = color1;
      document.getElementById(StructureType + "-44").style.background = color2;
      document.getElementById(StructureType + "-261").style.background = color3;
    }
    if (previuosID == 42) {
      document.getElementById(StructureType + "-42").style.background = color2;
      document.getElementById(StructureType + "-262").style.background = color3;
    }
  }
  function showInfo(ID) {

    let e = ID.split('-')[1];
    Setinfostyle(ID);
    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    if (previuosID != "" && previuosID != null) {
      setPreviousValue(ID);
    }
    document.getElementById(StructureType + "-85").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-86").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-217").style.background = '#f7f7f7';
    if (StructureType !== "Apartment" && StructureType !== "Condo") {
      document.getElementById(StructureType + "-96").style.background = 'transparent';
    }
    if (StructureType == "Apartment" || StructureType == "Condo") {
      document.getElementById(StructureType + "-79").style.background = 'transparent';

      document.getElementById(StructureType + "-71").style.background = '#f7f7f7';
    }

    document.getElementById("PreviousID").value = e;

    if (e == 256) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-256").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-36").style.backgroundColor;

      document.getElementById("color3").value = document.getElementById(StructureType + "-258").style.backgroundColor;
      document.getElementById(StructureType + "-258").style.background = '#fffce6';


      document.getElementById(StructureType + "-256").style.background = '#fffce6';
      document.getElementById(StructureType + "-36").style.background = '#fffce6';

    }
    if (e == 3256) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-3256").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-336").style.backgroundColor;

      document.getElementById("color3").value = document.getElementById(StructureType + "-3258").style.backgroundColor;
      document.getElementById(StructureType + "-3258").style.background = '#fffce6';


      document.getElementById(StructureType + "-3256").style.background = '#fffce6';
      document.getElementById(StructureType + "-336").style.background = '#fffce6';

    }
    if (e == 41) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-41").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-259").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-255").style.backgroundColor;
      document.getElementById(StructureType + "-41").style.background = '#fffce6';
      document.getElementById(StructureType + "-259").style.background = '#fffce6';
      document.getElementById(StructureType + "-255").style.background = '#fffce6';
    }
    if (e == 43) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-278").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-43").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-260").style.backgroundColor;
      document.getElementById(StructureType + "-43").style.background = '#fffce6';
      document.getElementById(StructureType + "-260").style.background = '#fffce6';
      document.getElementById(StructureType + "-278").style.background = '#fffce6';
    }
    if (e == 44) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-279").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-44").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-261").style.backgroundColor;
      document.getElementById(StructureType + "-44").style.background = '#fffce6';
      document.getElementById(StructureType + "-261").style.background = '#fffce6';
      document.getElementById(StructureType + "-279").style.background = '#fffce6';
    }
    if (e == 42) {
      document.getElementById("color2").value = document.getElementById(StructureType + "-42").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-262").style.backgroundColor;
      document.getElementById(StructureType + "-42").style.background = '#fffce6';
      document.getElementById(StructureType + "-262").style.background = '#fffce6';
    }
    if (e == 3256) {

      document.getElementById("HSales Cost Breakdown" + StructureType).innerText = "Estimated Value";
      document.getElementById("ISales Cost Breakdown" + StructureType).innerText = "The estimated value of the improved property when completed.";

      SetIsHeader("Estimated Value");
      SetIsinfo("The estimated value of the improved property when completed.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'noneblock';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'block';
    }

    if (e == 256) {

      document.getElementById("HSite Potential" + StructureType).innerText = "Estimated Value";
      document.getElementById("ISite Potential" + StructureType).innerText = "The estimated value of the improved property when completed.";
      SetIsHeader("Estimated Value");
      SetIsinfo("The estimated value of the improved property when completed.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'block';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'none';
    }
    if (e == 41) {
      document.getElementById("HSales Cost Breakdown" + StructureType).innerText = "Sales Commissions";
      document.getElementById("ISales Cost Breakdown" + StructureType).innerText = "The real estate commissions paid to the brokers for selling the improved property.";
      SetIsHeader("Sales Commissions");
      SetIsinfo("The real estate commissions paid to the brokers for selling the improved property.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'none';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'block';
    }
    if (e == 43) {
      document.getElementById("HSales Cost Breakdown" + StructureType).innerText = "Escrow Fees";
      document.getElementById("ISales Cost Breakdown" + StructureType).innerText = "The fees associated with escrow such as closing costs, transfer fees and etc.";
      SetIsHeader("Escrow Fees");
      SetIsinfo("The fees associated with escrow such as closing costs, transfer fees and etc.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'none';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'block';
    }
    if (e == 44) {
      document.getElementById("HSales Cost Breakdown" + StructureType).innerText = "Marketing & Staging Costs";
      document.getElementById("ISales Cost Breakdown" + StructureType).innerText = "The fees associated with marketing or preparation for the sale of the property.";
      SetIsHeader("Marketing & Staging Costs");
      SetIsinfo("The fees associated with marketing or preparation for the sale of the property.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'none';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'block';
    }
    if (e == 42) {
      document.getElementById("HSales Cost Breakdown" + StructureType).innerText = "Excise Tax";
      document.getElementById("ISales Cost Breakdown" + StructureType).innerText = "The taxes collected by the government for the sale of the property.";
      SetIsHeader("Excise Tax");
      SetIsinfo("The taxes collected by the government for the sale of the property.");
      SetIsDisplay("info");
      document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Land Analysis" + StructureType).style.display = 'none';
      document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
      document.getElementById("Site Potential" + StructureType).style.display = 'none';
      document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'block';
    }

  }
  if (props.id == 191) {
    return (
      <>

        <div class="col-md-11">
          <div class="row" >
            <div class="col-md-9 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-3 col-5 test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                class={IsStyle}
                style={{ borderRadius: "5px", marginBottom: "5px", paddingLeft: "2em" }}
              /></div></div>
        </div>
      </>
    );
  }
  if (props.id == 194) {
    return (
      <>
        <div class="col-md-3  col-3">
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px", fontWeight: "550" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 152) {
    return (
      <>
        <div class="col-md-8 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1">{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px", fontWeight: "550" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 193) {
    return (
      <>
        <div class="col-md-3 col-5 ">
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 78) {
    return (
      <>
        <div class="col-md-8 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1">{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 192) {
    return (
      <>

        <div class="col-md-3 col-5">
          <label class="d-block text center" style={{ width: "100%", textAlign: "center" }}>Apartment
          </label>
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 132) {
    return (
      <>
        <div class="col-md-8 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1 mt-11" style={{ marginTop: "10%" }}>{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><label class="d-block" style={{ textAlign: "center" }}>Per Unit
            </label><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 74) {
    return (
      <>
        <div class="col-md-5">
          <div class="row">
            <div class="col-md-6 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-3 col-5 test1"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
        <div class="col-2 ismobile"></div>
      </>
    );
  }
  if (props.id == 131) {
    return (
      <>
        <div class="col-md-6">
          <div class="row" style={{ textAlign: "left", marginLeft: "0%" }}>
            <div class="col-md-8 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-4 col test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 76) {
    return (
      <>
        <div class="row " style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "110%", marginBottom: "10%", marginTop: "0%" }}></div>

        <div class="col-md-5">
          <div class="row">
            <div class="col-md-6 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-3 col-5 test1"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              class={IsStyle}
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
        <div class="col-2 ismobile"></div>
      </>
    );
  }
  if (props.id == 72) {
    return (
      <>
        <div class="col-md-3 col-5" style={{ marginTop: "-5%" }}>
          <div class="row" style={{ marginLeft: "-15px", marginRight: "-15px" }}>

            <div class="col-md-5 col" style={{ marginTop: "10%" }}> <label class="mr-1">Rent Per Unit
            </label></div>
            <div class="col-md-7 col" ><label class="d-block" style={{ textAlign: "center" }}>Monthly</label>
              <div class="test"> <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                class={IsStyle}
                style={{ borderRadius: "5px", marginBottom: "5px" }}
              /></div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 73) {
    return (
      <>
        <div class="col-md-3 col-5" style={{ marginTop: "-5%" }}><label class="d-block" style={{ textAlign: "center" }}>Yearly</label>
          <div class="test"> <input
            type="text"
            key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id}
            value={value}
            onChange={onChange}
            class={IsStyle}
            readOnly
            style={{ borderRadius: "5px", marginBottom: "5px" }}
          />
          </div></div>
      </>
    );
  }
  if (props.id == 253 || props.id == 3253 || props.id == 39 || props.id == 3254 || props.id == 339 || props.id == 254) {
    if (props.id == 3253 || props.id == 253) {


      return (

        <>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 251 || props.id == 3251 || props.id == 38 || props.id == 338 || props.id == 252 || props.id == 3252) {
    if (props.id == 251 || props.id == 3251) {


      return (

        <>
          <div class="col-md-3 " >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 37 || props.id == 337 || props.id == 249 || props.id == 250 || props.id == 3250 || props.id == 3249) {
    if (props.id == 249 || props.id == 3249) {


      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: '100%' }} >
              <div class="col-md-3"></div>
              <div class="col-md-2  col-2"><label class="d-block text-center">Per sqft </label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3 " >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 3258 || props.id == 336 || props.id == 256 || props.id == 3256 || props.id == 36 || props.id == 258) {

    if (props.id == 258) {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
          <div class="row" style={{ width: "100%", marginTop: "2%" }}>



            <p class="col-md-11 col " style={{ textAlign: "justify", fontSize: "small", marginBottom: "0px" }}>
              User to verify site potential
              information, software only references to city code, software does not reference to
              anything outside of city code to perform projections such as easements, covenants,
              restrictions and etc.
            </p></div>

        </>

      );
    }
    if (props.id == 3258) {
      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>


        </>
      );
    }
    else {
      if (props.id == 3256 || props.id == 256) {
        if (props.structureType == "Single Family") {
          return (

            <>

              <div class="col-md-5" >
                <div class="from   justify-content-between  align-items-center ">
                  <label class=""><u>Total Estimated Value</u>
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>

                  </label>



                </div>
              </div>
              <div class="col-2 ismobile"></div>
              <div class="col-md-2 col-2" style={{ display: "none" }}>
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}
                      readOnly={IsReadOnly}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>

            </>
          );
        }
        else {

          return (

            <>
              <div class="col-md-12 input-box1 ">
                <div class="row" style={{ width: "100%" }}>
                  <div class="col-md-3"></div>
                  <div class="col-md-2 col-2"><label class="d-block text-center">Per sqft</label></div>
                  <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3" >
                <div class="from   justify-content-between  align-items-center ">
                  <label class="">{props.name.split('Per')[0]}
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>

                  </label>



                </div>
              </div>

              <div class="col-md-2 col-2">
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}
                      readOnly={IsReadOnly}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>
            </>
          );
        }


      } else {
        if (props.structureType == "Single Family") {
          return (

            <>


              <div class="col-md-3 col-5" >
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }
        else {
          return (

            <>


              <div class="col-md-3 col-5" >
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}
                      readOnly={IsReadOnly}
                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>
            </>
          );
        }
      }
    }
  }
  if (props.id == 41 || props.id == 259 || props.id == 255 || props.id == 278 || props.id == 279 || props.id == 375) {
    if (props.id == 41) {


      return (

        <>
          <div class="col-md-12 input-box1 mt-3">
            <div class="row" style={{ width: "100%" }}>
              <div class="col-md-5 col"></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-5" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {
      if (props.id == 259) {
        return (

          <>


            <div class="col-md-2 col" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (

          <>


            <div class="col-md-1 col-2" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    // style={{paddingLeft:"1em"}}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );

      }
    }
  }
  if (props.id == 43 || props.id == 260) {
    if (props.id == 43) {


      return (

        <>
          <div class="col-md-5 " >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-2 col" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 44 || props.id == 261) {
    if (props.id == 44) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-2 col" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 42 || props.id == 262) {
    if (props.id == 42) {


      return (

        <>
          <Dialog
            open={modalShow}
            onClose={() => setModalShow(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <i class="fa fa-times" aria-hidden="true" onClick={() => setModalShow(false)} style={{ float: "right" }}></i>
              <DialogContentText id="alert-dialog-description" >
                <img src="/assets/img/excisetax.png"></img>
              </DialogContentText>
            </DialogContent>

          </Dialog>
          <div class="col-md-5" >
            <div class="from    align-items-center ">
              <a onClick={openpopup} ><img style={{ width: "10%" }} class="iconimg" src="/assets/img/outside-page-LB.svg"></img>
              </a> <label class=""  >{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  if (props.id == 134 || props.id == 140) {
    if (props.id == 134) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from   justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]}</u>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ fontWeight: "550" }}
                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ fontWeight: "550" }}
                />
              </div>
            </div>
          </div>


        </>
      );
    }
  }
  if (props.id == 130 || props.id == 257) {
    if (props.id == 130) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3  col-5" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  else {

    return (
      <>

      </>
    );
  }
}
export default SaleCost;
